module.exports = __webpack_public_path__ + "img/login_center.690cc124.png";